import { createQueryKeys } from '@lukemorales/query-key-factory';

import type { Shops } from '@/Swagger';
import { aimsApi } from '@/axios/AclosetApi';

export const 원스톱_솔루션_정산_쿼리 = createQueryKeys('corner-logis-settlements', {
  정산_목록_조회: ({ shopID, query }: { shopID: string; query: Shops.CornerLogisSettlementsList.RequestQuery }) => ({
    queryKey: [shopID, query] as const,
    queryFn: () => aimsApi.shops.cornerLogisSettlementsList({ ...query, shopId: shopID }).then(v => v.data),
  }),

  실시간_정산_조회: ({ shopID }: { shopID: string }) => ({
    queryKey: [shopID] as const,
    queryFn: () => aimsApi.shops.cornerLogisSettlementsRealtimeList(shopID).then(v => v.data),
  }),

  결제_상태_조회: ({ shopID }: { shopID: string }) => ({
    queryKey: [shopID] as const,
    queryFn: () => aimsApi.shops.cornerLogisSettlementsPaymentStatusList(shopID).then(v => v.data),
  }),
});
